<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-25 17:00:46
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-09-23 14:19:15
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/components/arrowRight.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="guide" :style="getBorderColor">
    <div class="iconfont" :style="getMainColor">{{ `\ue6aa` }}</div>
  </div>
</template>
<script>
export default {
  name: 'arrowRight',
  props: {
    mainColor: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    getMainColor() {
      return this.mainColor ? `color:${this.mainColor};` : 'color:#00c4c9'
    },
    getBorderColor() {
      return this.mainColor ? `border-color:${this.mainColor};` : 'border-color:#00c4c9'
    },
  },
  methods: {},
  mounted() { }
}
</script>
<style scoped lang="less">
.guide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border: 1px solid #00C4C9;
  box-sizing: border-box;
  border-radius: 50%;

  div {
    position: relative;
    color: #00C4C9;
    font-size: 13px;
    line-height: 1.2;
    left: 0.5px;
    top: 0.5px;
  }
}
</style>